import React from 'react';

interface UsetifulProps {
  app_id?: string;
  user_id?: string | number;
  language?: string;
}

declare global {
  interface Window {
    usetiful?: any;
    usetifulTags?: Record<string, unknown>;
  }
}

const Usetiful = ({ app_id, user_id, language }: UsetifulProps) => {
  React.useEffect(() => {
    if (!app_id || !language) {
      return;
    }
    const initUsetiful = () => {
      window.usetifulTags = { userId: user_id, language };

      window.usetiful =
        window.usetiful ||
        function (...args: any[]) {
          (window.usetiful.q = window.usetiful.q || []).push(args);
        };

      if (!document.querySelector(`script[src*="usetiful.js"]`)) {
        (function (w, d, s) {
          const a = d.getElementsByTagName('head')[0];
          const r = d.createElement('script');
          // @ts-ignore
          r.async = 1;
          r.src = s;
          r.setAttribute('id', 'usetifulScript');
          r.dataset.token = app_id;
          a.appendChild(r);
        })(window, document, 'https://www.usetiful.com/dist/usetiful.js');
      }
    };

    initUsetiful();

    return () => {
      if (window.usetiful) {
        window.usetiful('destroy');
      }
    };
  }, [app_id, user_id, language]);

  return null;
};

export default Usetiful;
